import type { CategoryKey, SampleArticle } from "./types";

const FR_CONTENT: Record<CategoryKey, SampleArticle[]> = {
  "actualites-generales": [
    {
      id: "ag-1",
      kicker: "Politique",
      title: "Le gouvernement presente son budget rectificatif devant l'Assemblee",
      dek: "Trois milliards d'euros redeployes vers la sante et l'education, un milliard prelevee sur les credits d'armement.",
      byline: "Marie Lacombe",
      date: "15 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1541872703-74c5e44368f9?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le ministre des Comptes publics a detaille mardi devant les deputes les arbitrages d'un texte que l'opposition juge deja insuffisant.",
        "La majorite revendique un effort historique sur les services publics. Les syndicats attendent les decrets d'application avant de se prononcer.",
      ],
    },
    {
      id: "ag-2",
      kicker: "International",
      title: "Cessez-le-feu prolonge dans le Sahel apres une mediation regionale",
      dek: "La CEDEAO obtient une extension de soixante jours et l'ouverture d'un couloir humanitaire au nord du pays.",
      byline: "Jean-Baptiste Roux",
      date: "15 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Les negociateurs ont travaille trente-six heures sans interruption a Niamey.",
        "Plusieurs chancelleries occidentales saluent l'accord mais s'inquietent de l'absence de garanties sur les livraisons d'armes.",
      ],
    },
    {
      id: "ag-3",
      kicker: "Justice",
      title: "Le proces du dossier Verra s'ouvre apres huit ans d'instruction",
      dek: "Quinze prevenus, trois cents temoins, sept mois d'audience programmee a la cour d'appel de Lyon.",
      byline: "Sophie Aubert",
      date: "14 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&w=1600&q=80",
      body: [
        "L'enquete porte sur des soupcons de corruption et de prise illegale d'interets dans l'attribution de marches publics.",
        "Les parties civiles reclament la diffusion integrale des debats sur la chaine parlementaire.",
      ],
    },
    {
      id: "ag-4",
      kicker: "Societe",
      title: "Hopital public : la greve illimitee gagne dix nouveaux CHU",
      dek: "Les soignants reclament la titularisation de quinze mille contractuels et une revalorisation indiciaire.",
      byline: "Camille Berger",
      date: "14 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1551601651-2a8555f1a136?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le mouvement, lance la semaine derniere a Marseille, touche desormais Bordeaux, Nantes, Strasbourg et Lille.",
        "Le ministere annonce une reunion d'urgence vendredi avec l'ensemble des organisations syndicales.",
      ],
    },
    {
      id: "ag-5",
      kicker: "Sciences",
      title: "Le CEA confirme la stabilite d'un nouveau materiau supraconducteur",
      dek: "Apres dix-huit mois d'essais, l'alliage developpe a Saclay tient sa promesse a temperature ambiante.",
      byline: "Pierre Vasseur",
      date: "13 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Les applications industrielles concernent en priorite le transport d'electricite a longue distance.",
        "Trois consortiums europeens ont deja depose des demandes de licence aupres du CEA.",
      ],
    },
    {
      id: "ag-6",
      kicker: "Climat",
      title: "L'Europe valide une feuille de route 2035 sur le carbone industriel",
      dek: "Bruxelles fixe un cap contraignant aux cimentiers, aux acieries et aux raffineries du continent.",
      byline: "Helene Carpentier",
      date: "13 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1473773508845-188df298d2d1?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le texte prevoit des sanctions pouvant atteindre cinq pour cent du chiffre d'affaires en cas de non-respect.",
        "Les federations industrielles reclament un mecanisme d'ajustement aux frontieres plus protecteur.",
      ],
    },
  ],
  "actualites-locales": [
    {
      id: "al-1",
      kicker: "Mairie",
      title: "Le conseil municipal vote le rachat de l'ancienne usine textile",
      dek: "Le batiment, classe au patrimoine industriel, accueillera une mediatheque et un tiers-lieu en 2028.",
      byline: "Lucie Marchand",
      date: "15 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1448630360428-65456885c650?auto=format&fit=crop&w=1600&q=80",
      body: [
        "L'achat est budgete a quatre millions d'euros, financee par un emprunt sur vingt ans.",
        "L'opposition denonce une operation immobiliere precipitee et reclame une concertation publique elargie.",
      ],
    },
    {
      id: "al-2",
      kicker: "Transport",
      title: "Le tramway de la ligne C ouvrira avec deux mois d'avance",
      dek: "Les essais en charge debutent lundi, mise en service commerciale prevue pour la rentree.",
      byline: "Antoine Verger",
      date: "15 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1474487548417-781cb71495f3?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le chantier, lance en 2022, aura mobilise sept cents ouvriers et coute deux cent dix millions d'euros.",
        "La metropole annonce la gratuite des transports le week-end inaugural.",
      ],
    },
    {
      id: "al-3",
      kicker: "Education",
      title: "Carte scolaire : trois ecoles maintenues apres mobilisation des parents",
      dek: "Le rectorat revient sur les fermetures programmees a Cesson, Villejean et Maurepas.",
      byline: "Nadia Sellier",
      date: "14 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Quatre cents familles avaient signe la petition lancee en mars.",
        "La directrice academique reconnait avoir sous-estime la dynamique demographique du nord-est rennais.",
      ],
    },
    {
      id: "al-4",
      kicker: "Logement",
      title: "Loyers plafonnes : un nouveau perimetre couvre cinq communes",
      dek: "L'encadrement entre en vigueur au 1er juillet, six mille logements concernes.",
      byline: "Olivier Renault",
      date: "13 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Les bailleurs disposent de six mois pour mettre leurs annonces en conformite.",
        "L'agglomeration ouvre un guichet unique pour accompagner les proprietaires et les locataires.",
      ],
    },
    {
      id: "al-5",
      kicker: "Sport",
      title: "Le club de basket monte en Pro B apres une saison invaincue a domicile",
      dek: "Vingt-deux victoires sur vingt-deux matchs, un record qui restera dans les archives du club centenaire.",
      byline: "Romain Ferrand",
      date: "13 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1546519638-68e109498ffc?auto=format&fit=crop&w=1600&q=80",
      body: [
        "L'entraineur prolonge pour deux saisons supplementaires.",
        "La salle Pierre-Mendes-France passera de trois mille a quatre mille places d'ici septembre 2027.",
      ],
    },
    {
      id: "al-6",
      kicker: "Patrimoine",
      title: "La cathedrale rouvre sa nef apres trois ans de restauration",
      dek: "Les vitraux du XIIIe siecle retrouvent leur eclat d'origine, la flute du grand orgue restera fermee jusqu'en automne.",
      byline: "Beatrice Lemoine",
      date: "12 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1473177104440-ffee2f376098?auto=format&fit=crop&w=1600&q=80",
      body: [
        "L'archeveche organise une journee portes ouvertes le 18 mai.",
        "Le chantier de la flute, finance par souscription publique, atteint deja soixante pour cent de l'objectif.",
      ],
    },
  ],
  "business-finance": [
    {
      id: "bf-1",
      kicker: "Marches",
      title: "Le CAC 40 cloture a un nouveau plus haut historique",
      dek: "L'indice parisien franchit 8 920 points, porte par la chimie et le luxe.",
      byline: "David Lefranc",
      date: "15 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Les volumes restent inferieurs a la moyenne mensuelle, signe d'une progression portee par quelques convictions.",
        "Les analystes restent prudents avant la publication des chiffres de l'inflation europeenne vendredi.",
      ],
    },
    {
      id: "bf-2",
      kicker: "M&A",
      title: "Veolia confirme les discussions exclusives autour d'une cible nordique",
      dek: "L'operation pourrait depasser quatre milliards d'euros, financement deja pre-engage.",
      byline: "Claire Hubert",
      date: "15 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le conseil d'administration se reunit jeudi pour examiner les modalites definitives.",
        "L'autorite de la concurrence a deja ete informee a titre confidentiel.",
      ],
    },
    {
      id: "bf-3",
      kicker: "Banques",
      title: "BNP Paribas releve son objectif de marge nette d'interet",
      dek: "Le directeur financier table sur 2,5 milliards d'euros supplementaires d'ici 2027.",
      byline: "Mehdi Saidi",
      date: "14 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le programme de rachat d'actions est releve a quatre milliards d'euros pour l'exercice en cours.",
        "Les analystes saluent la trajectoire mais s'interrogent sur l'exposition residuelle au commercial real estate americain.",
      ],
    },
    {
      id: "bf-4",
      kicker: "Energie",
      title: "TotalEnergies signe un partenariat de dix ans avec un consortium asiatique sur le GNL",
      dek: "L'accord couvre douze millions de tonnes annuelles a partir de 2028.",
      byline: "Solene Mercier",
      date: "14 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=1600&q=80",
      body: [
        "L'investissement initial est estime a trois milliards et demi d'euros.",
        "L'accord conditionne quatre milliards supplementaires a l'obtention des autorisations environnementales.",
      ],
    },
    {
      id: "bf-5",
      kicker: "Tech",
      title: "Mistral AI prepare un nouveau tour de table de deux milliards de dollars",
      dek: "La startup parisienne valoriserait son entreprise au dela de quinze milliards.",
      byline: "Julien Pasquier",
      date: "13 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Plusieurs fonds souverains europeens se positionneraient sur l'operation.",
        "L'objectif est de financer la prochaine generation de modeles open weight et le deploiement industriel.",
      ],
    },
    {
      id: "bf-6",
      kicker: "Macro",
      title: "Inflation : la BCE confirme sa trajectoire de baisse des taux",
      dek: "Une nouvelle reduction de 25 points de base est attendue en juin.",
      byline: "Yves Brunet",
      date: "13 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=1600&q=80",
      body: [
        "La presidente de la BCE insiste sur la dependance aux donnees economiques.",
        "Les marches anticipent deux baisses supplementaires d'ici la fin de l'annee.",
      ],
    },
  ],
  "culture-magazine": [
    {
      id: "cm-1",
      kicker: "Cinema",
      title: "Cannes 2026 : le palmares qui rebat les cartes du cinema d'auteur",
      dek: "La Palme d'or a une realisatrice islandaise inconnue il y a deux ans, prix d'interpretation partage.",
      byline: "Aurelie Vasseur",
      date: "15 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le jury preside par un romancier russe a tranche en faveur d'un cinema politique sans concession.",
        "Plusieurs distributeurs francais negocient deja les sorties d'automne.",
      ],
    },
    {
      id: "cm-2",
      kicker: "Litterature",
      title: "Une rentree litteraire a 459 romans, un seuil jamais atteint",
      dek: "Les editeurs independants progressent, les premiers romans francais reculent.",
      byline: "Eric Chapuis",
      date: "15 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Quinze maisons publient pour la premiere fois plus de dix titres dans la rentree.",
        "Les libraires alertent sur l'effet d'eviction des fonds editoriaux.",
      ],
    },
    {
      id: "cm-3",
      kicker: "Musique",
      title: "L'Opera de Paris confie sa nouvelle saison a une compositrice quebecoise",
      dek: "Cinq creations originales, deux reprises majeures, un cycle Wagner integral.",
      byline: "Manon Delbecq",
      date: "14 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le programme tranche avec la prudence des dernieres saisons.",
        "L'institution promet quatre nouvelles productions par an pendant la duree du mandat.",
      ],
    },
    {
      id: "cm-4",
      kicker: "Mode",
      title: "Les maisons de couture europeennes se preparent au printemps 2027",
      dek: "Retour de l'artisanat regional, baisse des collections industrielles, luxe responsable assume.",
      byline: "Salima Ouali",
      date: "14 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Quatre maisons annoncent la suppression complete des collections croisiere.",
        "Les ateliers regionaux d'Alsace et de Lozere recoivent les premieres commandes industrielles.",
      ],
    },
    {
      id: "cm-5",
      kicker: "Patrimoine",
      title: "Le Grand Palais retrouve son verriere apres dix ans de chantier",
      dek: "Inauguration officielle le 21 mai, programmation jusqu'en 2030 deja annoncee.",
      byline: "Vincent Charrier",
      date: "13 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le chantier a coute six cent millions d'euros, finances pour moitie par le mecenat.",
        "Une exposition consacree a Niki de Saint Phalle ouvrira la nouvelle programmation.",
      ],
    },
    {
      id: "cm-6",
      kicker: "Photographie",
      title: "Les Rencontres d'Arles consacrent les jeunes regards africains",
      dek: "Quinze expositions, dix premieres, un focus inedit sur le studio photographique de Lagos.",
      byline: "Karim Bensoussan",
      date: "13 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1522199755839-a2bacb67c546?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le festival accueille douze nouveaux lieux d'exposition cette annee.",
        "Les ateliers professionnels affichent complet trois mois avant l'ouverture.",
      ],
    },
  ],
  sport: [
    {
      id: "sp-1",
      kicker: "Football",
      title: "Le PSG arrache le titre dans les arrets de jeu de la derniere journee",
      dek: "Score final 3 a 2, doublet en seconde periode, record de spectateurs au Parc.",
      byline: "Maxime Rollin",
      date: "15 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=1600&q=80",
      body: [
        "L'entraineur termine sa premiere saison invaincu en championnat a domicile.",
        "Le club annonce d'ores et deja un mercato resserre, centre sur deux postes prioritaires.",
      ],
    },
    {
      id: "sp-2",
      kicker: "Tennis",
      title: "Roland-Garros : la nouvelle generation francaise franchit les huitiemes",
      dek: "Quatre joueurs tricolores en huitiemes de finale, premiere depuis dix-neuf ans.",
      byline: "Lea Doucet",
      date: "15 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1542144612-1b3641ec3459?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le tableau feminin reserve egalement deux belles surprises.",
        "Les organisateurs envisagent d'avancer l'horaire des sessions de soiree.",
      ],
    },
    {
      id: "sp-3",
      kicker: "Cyclisme",
      title: "Giro 2026 : l'echappee fleuve s'impose dans les Dolomites",
      dek: "Quinze coureurs partis a 200 kilometres de l'arrivee, le maillot rose change d'epaules.",
      byline: "Hugo Vidal",
      date: "14 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le grimpeur colombien empoche la 9e etape avec quatre minutes d'avance sur le peloton.",
        "La derniere semaine s'annonce explosive avec quatre etapes de montagne consecutives.",
      ],
    },
    {
      id: "sp-4",
      kicker: "Rugby",
      title: "Top 14 : la finale opposera Toulouse a La Rochelle pour la troisieme fois",
      dek: "Les Maritimes retrouvent le Stade de France apres une saison reguliere ecrasante.",
      byline: "Pierre Lacaze",
      date: "14 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1518091043644-c1d4457512c6?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Toulouse aligne trois internationaux supplementaires depuis la demi-finale.",
        "Les billets pour la finale ont ete ecoules en quarante minutes.",
      ],
    },
    {
      id: "sp-5",
      kicker: "Basket",
      title: "Wembanyama porte les Spurs en finale de la conference Ouest",
      dek: "42 points, 18 rebonds, 7 contres, une ligne de stats inedite dans l'histoire des playoffs.",
      byline: "Theo Mansouri",
      date: "13 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1505666287802-931dc83948e9?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Le pivot francais devient le plus jeune joueur a depasser 200 contres en playoffs.",
        "Les Spurs affronteront Denver des dimanche pour le titre de la conference.",
      ],
    },
    {
      id: "sp-6",
      kicker: "Athletisme",
      title: "Diamond League : trois records francais battus en une soiree",
      dek: "100 metres haies, perche, 5 000 metres, tous tombes sous les yeux du public parisien.",
      byline: "Claire Vidal",
      date: "13 mai 2026",
      imageUrl: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?auto=format&fit=crop&w=1600&q=80",
      body: [
        "L'equipe de France realise sa meilleure soiree depuis les Mondiaux 2003.",
        "La prochaine etape se court a Oslo dans deux semaines.",
      ],
    },
  ],
};

const EN_CONTENT: Record<CategoryKey, SampleArticle[]> = {
  "actualites-generales": [
    {
      id: "ag-en-1",
      kicker: "Politics",
      title: "Lawmakers approve emergency budget after marathon overnight session",
      dek: "Three billion redirected to health and education, defense outlays trimmed by one billion.",
      byline: "James Holloway",
      date: "May 15, 2026",
      imageUrl: "https://images.unsplash.com/photo-1541872703-74c5e44368f9?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The vote passed 312 to 198 just before dawn.",
        "Opposition leaders called the package insufficient and pledged a constitutional challenge by week's end.",
      ],
    },
    {
      id: "ag-en-2",
      kicker: "World",
      title: "Sahel ceasefire extended sixty days after regional mediation",
      dek: "ECOWAS secures a humanitarian corridor, Western capitals press for arms verification.",
      byline: "Adwoa Mensah",
      date: "May 15, 2026",
      imageUrl: "https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Negotiators worked thirty-six hours straight in Niamey.",
        "Aid agencies say the corridor needs guarantees on both sides before convoys can move.",
      ],
    },
    {
      id: "ag-en-3",
      kicker: "Justice",
      title: "Verra trial opens after eight years of investigation",
      dek: "Fifteen defendants, three hundred witnesses, seven months of hearings expected in Lyon.",
      byline: "Sophie Aubert",
      date: "May 14, 2026",
      imageUrl: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Prosecutors allege a decade-long scheme to rig public works contracts.",
        "Civil parties want the proceedings broadcast on the parliamentary channel.",
      ],
    },
    {
      id: "ag-en-4",
      kicker: "Society",
      title: "Hospital strike spreads to ten more teaching centers",
      dek: "Workers demand permanent contracts for fifteen thousand staff and an indexed pay raise.",
      byline: "Camille Berger",
      date: "May 14, 2026",
      imageUrl: "https://images.unsplash.com/photo-1551601651-2a8555f1a136?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The movement, born in Marseille last week, now reaches Bordeaux, Nantes and Lille.",
        "Health ministry sets emergency talks with all unions for Friday.",
      ],
    },
    {
      id: "ag-en-5",
      kicker: "Science",
      title: "Saclay lab confirms a stable room-temperature superconductor",
      dek: "Eighteen months of trials validate the alloy. Industrial licensing applications are already in.",
      byline: "Pierre Vasseur",
      date: "May 13, 2026",
      imageUrl: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Three European consortia have filed for exclusive transmission-line use.",
        "Independent labs in Tokyo and Boston are running their own replications.",
      ],
    },
    {
      id: "ag-en-6",
      kicker: "Climate",
      title: "EU adopts binding 2035 path on industrial carbon",
      dek: "Cement, steel and refineries face penalties up to five percent of revenue.",
      byline: "Helene Carpentier",
      date: "May 13, 2026",
      imageUrl: "https://images.unsplash.com/photo-1473773508845-188df298d2d1?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The text passed with a comfortable majority despite intense industry lobbying.",
        "Industrial federations want a stronger border adjustment to protect competitiveness.",
      ],
    },
  ],
  "actualites-locales": [
    {
      id: "al-en-1",
      kicker: "City Hall",
      title: "Council approves purchase of the old textile mill",
      dek: "The listed industrial site will host a library and a co-working hub by 2028.",
      byline: "Lucy Markham",
      date: "May 15, 2026",
      imageUrl: "https://images.unsplash.com/photo-1448630360428-65456885c650?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The four-million-euro purchase is funded by a twenty-year bond.",
        "Opposition members say the deal was rushed without proper public consultation.",
      ],
    },
    {
      id: "al-en-2",
      kicker: "Transit",
      title: "Tram line C opens two months ahead of schedule",
      dek: "Load tests start Monday, commercial service begins after summer.",
      byline: "Antoine Verger",
      date: "May 15, 2026",
      imageUrl: "https://images.unsplash.com/photo-1474487548417-781cb71495f3?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The four-year project mobilized seven hundred workers.",
        "The metropolitan area will offer free rides during opening weekend.",
      ],
    },
    {
      id: "al-en-3",
      kicker: "Schools",
      title: "Three schools saved from closure after parents mobilize",
      dek: "The local authority reverses cuts in three working-class districts.",
      byline: "Nadia Sellier",
      date: "May 14, 2026",
      imageUrl: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Four hundred families had signed a March petition.",
        "The director of education concedes that demographic forecasts were wrong.",
      ],
    },
    {
      id: "al-en-4",
      kicker: "Housing",
      title: "Rent caps extended to five neighboring towns",
      dek: "Six thousand units enter the regulated zone on July 1.",
      byline: "Olivier Renault",
      date: "May 13, 2026",
      imageUrl: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Landlords have six months to align listings with the new ceilings.",
        "A one-stop helpdesk opens next week for both owners and tenants.",
      ],
    },
    {
      id: "al-en-5",
      kicker: "Sport",
      title: "Local basketball team promoted after undefeated home season",
      dek: "Twenty-two wins from twenty-two home games. A first in the centenary club's history.",
      byline: "Romain Ferrand",
      date: "May 13, 2026",
      imageUrl: "https://images.unsplash.com/photo-1546519638-68e109498ffc?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Head coach signs a two-year extension.",
        "The home arena gains a thousand seats by autumn 2027.",
      ],
    },
    {
      id: "al-en-6",
      kicker: "Heritage",
      title: "Cathedral nave reopens after three-year restoration",
      dek: "Thirteenth-century stained glass restored. The great organ remains closed until autumn.",
      byline: "Beatrice Lemoine",
      date: "May 12, 2026",
      imageUrl: "https://images.unsplash.com/photo-1473177104440-ffee2f376098?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The diocese opens public viewings on May 18.",
        "Public subscription for the organ has reached sixty percent of its target.",
      ],
    },
  ],
  "business-finance": [
    {
      id: "bf-en-1",
      kicker: "Markets",
      title: "CAC 40 closes at a fresh all-time high",
      dek: "The Paris index breaks 8,920, lifted by chemicals and luxury.",
      byline: "David Lefranc",
      date: "May 15, 2026",
      imageUrl: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Volume stayed below the monthly average, signaling a narrow rally.",
        "Analysts hold cautious notes ahead of Friday's eurozone inflation print.",
      ],
    },
    {
      id: "bf-en-2",
      kicker: "M&A",
      title: "Veolia confirms exclusive talks with a Nordic target",
      dek: "Deal could exceed four billion euros, with financing already lined up.",
      byline: "Claire Hubert",
      date: "May 15, 2026",
      imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The board reviews final terms on Thursday.",
        "Antitrust authorities have been informed under confidentiality.",
      ],
    },
    {
      id: "bf-en-3",
      kicker: "Banking",
      title: "BNP Paribas raises its net interest margin guidance",
      dek: "The CFO sees an additional 2.5 billion euros by 2027.",
      byline: "Mehdi Saidi",
      date: "May 14, 2026",
      imageUrl: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The buyback program is increased to four billion this year.",
        "Analysts welcome the trajectory but flag US commercial real estate exposure.",
      ],
    },
    {
      id: "bf-en-4",
      kicker: "Energy",
      title: "TotalEnergies signs a ten-year LNG deal with Asian consortium",
      dek: "Twelve million tonnes per year from 2028, an initial investment of 3.5 billion.",
      byline: "Solene Mercier",
      date: "May 14, 2026",
      imageUrl: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=1600&q=80",
      body: [
        "An additional four billion is contingent on environmental approvals.",
        "Local communities demand impact studies before the next milestone.",
      ],
    },
    {
      id: "bf-en-5",
      kicker: "Tech",
      title: "Mistral AI prepares a new two billion dollar funding round",
      dek: "The Paris startup would be valued above 15 billion.",
      byline: "Julien Pasquier",
      date: "May 13, 2026",
      imageUrl: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Several European sovereign funds reportedly join the round.",
        "The capital will fund the next generation of open-weight models and industrial deployment.",
      ],
    },
    {
      id: "bf-en-6",
      kicker: "Macro",
      title: "ECB confirms its rate-cutting trajectory",
      dek: "Markets expect another 25 basis points in June.",
      byline: "Yves Brunet",
      date: "May 13, 2026",
      imageUrl: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The president of the ECB stresses data dependence.",
        "Two more cuts are now priced in by year-end.",
      ],
    },
  ],
  "culture-magazine": [
    {
      id: "cm-en-1",
      kicker: "Cinema",
      title: "Cannes 2026: an upset Palme d'Or for an unknown Icelandic director",
      dek: "Best actress and actor prizes shared. Distributors scramble for European rights.",
      byline: "Aurelie Vasseur",
      date: "May 15, 2026",
      imageUrl: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The jury, led by a Russian novelist, rewarded politically charged cinema.",
        "Several French distributors are negotiating autumn release windows.",
      ],
    },
    {
      id: "cm-en-2",
      kicker: "Books",
      title: "A 459-novel autumn season, a record never seen before",
      dek: "Independent publishers gain ground while debut French novels keep slipping.",
      byline: "Eric Chapuis",
      date: "May 15, 2026",
      imageUrl: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Fifteen houses publish more than ten titles each for the first time.",
        "Booksellers warn of a crowding-out effect on backlist sales.",
      ],
    },
    {
      id: "cm-en-3",
      kicker: "Music",
      title: "Paris Opera entrusts its new season to a Quebec composer",
      dek: "Five world premieres, two major revivals, a full Wagner cycle.",
      byline: "Manon Delbecq",
      date: "May 14, 2026",
      imageUrl: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The program breaks with the cautious recent seasons.",
        "The institution promises four new productions per year for the duration of her tenure.",
      ],
    },
    {
      id: "cm-en-4",
      kicker: "Fashion",
      title: "European couture houses prep their spring 2027 lineup",
      dek: "Regional craft returns. Industrial collections shrink. Responsible luxury is the watchword.",
      byline: "Salima Ouali",
      date: "May 14, 2026",
      imageUrl: "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Four houses scrap their cruise collections entirely.",
        "Regional ateliers in Alsace and Lozere take their first industrial orders in years.",
      ],
    },
    {
      id: "cm-en-5",
      kicker: "Heritage",
      title: "Grand Palais glass roof reopens after a decade of works",
      dek: "Inauguration on May 21, programming already announced through 2030.",
      byline: "Vincent Charrier",
      date: "May 13, 2026",
      imageUrl: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The 600-million-euro project was half-funded by patronage.",
        "A Niki de Saint Phalle retrospective opens the new program.",
      ],
    },
    {
      id: "cm-en-6",
      kicker: "Photography",
      title: "Rencontres d'Arles features new African voices",
      dek: "Fifteen exhibitions, ten premieres, a focus on Lagos studio photography.",
      byline: "Karim Bensoussan",
      date: "May 13, 2026",
      imageUrl: "https://images.unsplash.com/photo-1522199755839-a2bacb67c546?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The festival adds twelve new venues this year.",
        "Professional workshops are sold out three months ahead of opening.",
      ],
    },
  ],
  sport: [
    {
      id: "sp-en-1",
      kicker: "Football",
      title: "PSG snatches the title in stoppage time on the final matchday",
      dek: "3-2 final score, second-half brace, attendance record at the Parc.",
      byline: "Maxime Rollin",
      date: "May 15, 2026",
      imageUrl: "https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The head coach finishes his first season unbeaten at home.",
        "The club announces a focused summer window on two priority positions.",
      ],
    },
    {
      id: "sp-en-2",
      kicker: "Tennis",
      title: "Roland-Garros: French youth break through to the round of 16",
      dek: "Four French players reach the last 16, a first in nineteen years.",
      byline: "Lea Doucet",
      date: "May 15, 2026",
      imageUrl: "https://images.unsplash.com/photo-1542144612-1b3641ec3459?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The women's draw delivers two notable upsets as well.",
        "Organizers may move evening sessions earlier to ease curfew tensions.",
      ],
    },
    {
      id: "sp-en-3",
      kicker: "Cycling",
      title: "Giro 2026: long-range breakaway prevails in the Dolomites",
      dek: "Fifteen riders, 200 km solo effort, the pink jersey changes hands.",
      byline: "Hugo Vidal",
      date: "May 14, 2026",
      imageUrl: "https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The Colombian climber wins stage 9 by four minutes over the peloton.",
        "Four mountain stages await in the final week.",
      ],
    },
    {
      id: "sp-en-4",
      kicker: "Rugby",
      title: "Top 14 final: Toulouse versus La Rochelle, third time in a row",
      dek: "The Maritimes return to the Stade de France after a dominant regular season.",
      byline: "Pierre Lacaze",
      date: "May 14, 2026",
      imageUrl: "https://images.unsplash.com/photo-1518091043644-c1d4457512c6?auto=format&fit=crop&w=1600&q=80",
      body: [
        "Toulouse fields three additional internationals since the semifinal.",
        "Tickets sold out in forty minutes.",
      ],
    },
    {
      id: "sp-en-5",
      kicker: "Basketball",
      title: "Wembanyama drives the Spurs to the Western Conference finals",
      dek: "42 points, 18 rebounds, 7 blocks. A stat line never seen before in playoff history.",
      byline: "Theo Mansouri",
      date: "May 13, 2026",
      imageUrl: "https://images.unsplash.com/photo-1505666287802-931dc83948e9?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The French center becomes the youngest player to clear 200 playoff blocks.",
        "The Spurs face Denver from Sunday for the conference crown.",
      ],
    },
    {
      id: "sp-en-6",
      kicker: "Athletics",
      title: "Diamond League: three French records fall in one Paris evening",
      dek: "100m hurdles, pole vault, 5000m, all broken in front of a sold-out crowd.",
      byline: "Claire Vidal",
      date: "May 13, 2026",
      imageUrl: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?auto=format&fit=crop&w=1600&q=80",
      body: [
        "The French team posts its best evening since the 2003 World Championships.",
        "Next stop is Oslo in two weeks.",
      ],
    },
  ],
};

export function getSampleArticles(category: string, language: string): SampleArticle[] {
  const dict = language === "en" ? EN_CONTENT : FR_CONTENT;
  const key = (category in dict ? category : "actualites-generales") as CategoryKey;
  return dict[key];
}
